import TextDE from "./de/impressum-text"
// TODO
import TextEN from "./de/impressum-text"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


export const Impressum = ({ lang }) => {

    let HeroText;
    let BackText;
    switch (lang) {
        case 'de': {
            HeroText = TextDE
            BackText = 'Zurück zur Startseite'
            break
        }
        case 'en': {
            HeroText = TextEN
            BackText = 'Back to start'
            break
        }
        default: {
            HeroText = TextEN
            BackText = 'Back to start'
            break
        }
    }

    return (
        <div className="m-auto relative bg-center w-11/12 flex items-center justify-center">
            <div className="text-center bg-gray-900 bg-opacity-50 backdrop-blur-md p-2 rounded-lg text-gray-200 h-4/6 flex flex-col">
                <HeroText className="self-center" />
                <a href="/" className="hover:underline p-3 m-auto"><FontAwesomeIcon icon={['fas', 'chevron-left']}/> {BackText}</a>
            </div>
        </div>
    )
}
